<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <admin-sidebar-menu v-if="admin" />
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Home</h3>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

          <div class="mentor-container primaryadmin-dashboard">
            <flash-message autoHide variant="success"></flash-message>
            <div class="list-users">
              <table-component v-bind:data="groups" :show-caption="false" :show-filter="false" :cache-key="7" cache-lifetime="0" ref="table7" :filter-no-results=no_result>
                  <table-column show="groupName" :sortable="true" label="GROUP NAME">
                    <template slot-scope="row">
                     <router-link :to="'/group-users/'+row.id">{{row.groupName}}</router-link>
                    </template>
                  </table-column>
                  <table-column show="parentGroupName" :sortable="false" label="PARENT GROUP">
                    <template slot-scope="row">
                      {{row.parentGroupName}}
                    </template>
                  </table-column>
                  <table-column :sortable="false">
                    <template slot-scope="row">
                    <button
                      class="btn btn-red btn-md input-height-15" @click=goToEdit(row.id)
                      >Edit</button>
                    </template>
                  </table-column>
              </table-component>
            </div>
          </div>



        </div>
      </div>
    </div>



  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import TableComponent from 'vue-table-component';
import axios from 'axios';
import router from '../../router/index.js';
import store from '../../store/store.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';

Vue.use(TableComponent, {
    tableClass: 'table-responsive table table-hover w-100',
    theadClass: '',
    tbodyClass: '',
    filterPlaceholder: 'Filter table…',
});

export default {
    data: function () {
        return {
            groups: [],
            no_result: 'Loading...',
            admin: false,
        }
    },
  components: {
    UserMenu,
    AdminSidebarMenu
  },
  methods: {
     goToEdit(groupId) {
       router.push("/edit-group/" + groupId);
     }
  },
  created() {
    var roles = this.$store.state.roles;
    if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
      this.admin = true;
    }
  },
  beforeCreate() {
      this.$store.dispatch('active_tab', '');
      axios('/accountgroups',
        {
          method: 'GET',
          params: {
            account_id: this.$store.state.user_accountid,
          }
        },
      )
      .then(response => {
            this.groups = response.data;
       })
      .catch(error => {

      });
  }
}
</script>

<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
a.show_more_list span {
  color: #FFF;
}
.custommessage {
  color: red;
}
.mentor-highlight {
 background-color: #e8e8e8;
}
.group-name {
  background-color: #e5e5e5;
  color: #000;
  font-size: 17px;
  padding: 5px;
}
.card {
  margin-bottom: 10px;
  min-height: 325px;
}
h2 {
 margin-bottom: 5px;
 font-size: 22px;
 color: #000;
}
.mentor-container {
  margin: 0px auto;
  width: 100%;
  padding-top: 0px;
}
.group_class {
  width: 90%;
  float: left;
  margin-bottom: 25px;
}
@media(max-width:991px) {
  .group_class {
    width: 97%;
    float: left;
    margin-bottom: 25px;
  }
}
@media(max-width:768px) {
  .group_class {
    width: 90%;
    float: left;
    margin-bottom: 25px;
  }
  .account_main_class, .account_class {
    min-height: auto;
  }
}
.name-list {
  text-indent: 10px;
  line-height: 25px;
  font-size: 15px;
}
.show_more_list {
  border: 1px solid #a9a9a9;
  border-radius: 5px;
  padding: 5px;
  color: #FFF;
  float: right;
  background-color: #a9a9a9;
}

hr {
  margin: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/primaryadmin/primadmin_dashboard.vue